import { render, staticRenderFns } from "./ConfigChecklistTemplates.vue?vue&type=template&id=60fcb2d2&scoped=true"
import script from "./ConfigChecklistTemplates.vue?vue&type=script&lang=js"
export * from "./ConfigChecklistTemplates.vue?vue&type=script&lang=js"
import style0 from "./ConfigChecklistTemplates.vue?vue&type=style&index=0&id=60fcb2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcb2d2",
  null
  
)

export default component.exports